module.exports = __webpack_public_path__ + "static/img/30_pro.8527ec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/30_pro.jpg
// module id = dw6K
// module chunks = 0